import React from 'react';
import profile from '../data/profile';

const About = () => {
  const stats = [
    { number: '10+', label: 'Projets réalisés' },
    { number: `${profile.identity.yearsOfExperience}+`, label: 'Années d\'expérience' },
    { number: '2+', label: 'Clients satisfaits' },
    { number: '90%', label: 'Taux de réussite' }
  ];

  const companies = profile.assets.companies;

  return (
    <section id="about" className="py-16 sm:py-20 bg-slate-800">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6 sm:space-y-8">
            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 text-center lg:text-left">
                À propos de <span className="text-gradient">moi</span>
              </h2>
              <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                {profile.identity.shortBio}
              </p>
              <p className="text-base sm:text-lg text-gray-300 leading-relaxed text-center lg:text-left">
                J'aime transformer des idées complexes en solutions élégantes et intuitives. Mon approche
                centrée sur l'utilisateur et mon attention aux détails me permettent de livrer des projets
                qui dépassent les attentes.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 sm:gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-2xl sm:text-3xl font-bold text-primary-400 mb-1 sm:mb-2">{stat.number}</div>
                  <div className="text-sm sm:text-base text-gray-300">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Companies */}
            <div className="text-center lg:text-left">
              <h3 className="text-lg sm:text-xl font-semibold text-white mb-3 sm:mb-4">Ils me font confiance</h3>
              <div className="flex items-center justify-center lg:justify-start space-x-4 sm:space-x-8 flex-wrap gap-4">
                {companies.map((company, index) => (
                  <div key={index} className="opacity-60 hover:opacity-100 transition-opacity duration-200">
                    <img
                      src={company.logo}
                      alt={company.name}
                      className="h-6 sm:h-8 w-auto"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative">
              <img
                src={profile.assets.aboutImage}
                alt="À propos"
                className="w-full max-w-md h-[400px] sm:h-[500px] lg:h-[600px] object-cover rounded-2xl shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
            </div>

            {/* Floating Experience Card */}
            <div className="absolute -bottom-4 -left-4 sm:-bottom-8 sm:-left-8 bg-white p-4 sm:p-6 rounded-xl shadow-xl">
              <div className="flex items-center space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-primary rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div>
                  <div className="text-lg sm:text-2xl font-bold text-dark-800">{profile.identity.yearsOfExperience}+</div>
                  <div className="text-xs sm:text-sm text-gray-600">Années d'expérience</div>
                </div>
              </div>
            </div>

            {/* Background Decoration */}
            <div className="absolute -z-10 top-4 right-4 sm:top-8 sm:right-8 w-full h-full bg-gradient-primary rounded-2xl opacity-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
